import React from 'react';
import TsrSvgIcon, { Icon, iconType } from '../../assets/icons';
import { JustifyContents } from '../../layout/models/JustifyContents';
import { Alignment } from '../../layout/models/Alignment';
import './styles.scss';
import { Label } from '../../inputs';
import { LoadingIcon } from '../../UI';
import { ButtonsPropsBase } from '../interfaces/Buttons';
import { uniqueId } from 'lodash';
import { ButtonType } from '../models/ButtonType';

type TypeOfButton = 'submit' | 'reset' | 'button';

interface ButtonsProps extends ButtonsPropsBase {
    justify?: JustifyContents;
    align?: Alignment;
    gap?: number;
    className?: string;
    icon?: iconType | Icon;
    alignItems?: Alignment;
    type?: TypeOfButton;
    chartIcon?: boolean;
    onClick: () => void;
}

export default function Button(props: ButtonsProps & ButtonsPropsBase): JSX.Element {
    const {
        type = props.type || ButtonType.Button,
        disabled = props.disabled || false,
        className = props.className || '',
        loading = props.loading || false,
        icon = props.icon || undefined,
        text = props.text || '',
        theme = props.theme || 'primary',
        justify = props.justify || JustifyContents.spaceBetween,
        align = props.align || Alignment.center,
        alignItems = props.align || Alignment.center,
        gap = props.gap || 20,
        chartIcon = props.chartIcon || false,
        onClick = props.onClick,
    } = props;
    const id = uniqueId('idButton-');
    return (
        <div
            className={'buttons-container' + (props.className ? ' ' + props.className : '')}
            style={{
                justifyContent: justify,
                alignContent: align,
                alignItems: alignItems,
                columnGap: gap,
            }}
        >
            <Label id={props.id || id} content={props.label} disabled={props.disabled} labelPosition={props.labelPosition}>
                <button
                    className={
                        'button' +
                        (className ? ' ' + className : '') +
                        (theme ? ' ' + theme : '') +
                        (disabled ? ' disabled' : '') +
                        (icon && !text ? ' only-icon-visible' : icon ? ' icon-visible' : ' icon-invisible')
                    }
                    onClick={() => {
                        !disabled && onClick();
                    }}
                    type={type}
                    tabIndex={props.disabled ? -1 : 0}
                >
                    {icon && (
                        <div className="button-icon">
                            {loading ? (
                                <div className="loading-icon">
                                    <LoadingIcon loading={loading} color={theme} />
                                </div>
                            ) : chartIcon ? (
                                <TsrSvgIcon icon={icon} pointer viewBox="0 0 10 10" />
                            ) : (
                                <TsrSvgIcon icon={icon} pointer />
                            )}
                        </div>
                    )}
                    <span>{text}</span>
                </button>
            </Label>
        </div>
    );
}
